import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {TreeNode} from 'primeng/api';

@Component({
    selector: 'pr-select-tree',
    templateUrl: './select-tree.component.html',
    styleUrls: ['./select-tree.component.scss']
})
export class SelectTreeComponent implements OnInit {

    @Input()
    set data(tree: PrTreeNode[]) {
        this.collapseAndIsPartialAllDisable(tree);
        this._data = tree;
        this.searchedData = [...tree];
    }

    get data() {
        return this.data;
    }

    @Input()
    set initialSelectedNodeTree(initialSelected) {
        if (initialSelected) {
            this._initialSelectedNodeTree = initialSelected;
            this.selected = [];
            this.dataArray = this.initialSelectedNodeTree.map((initialSelect) => initialSelect.id);
            this.checkNode(this._data, this.dataArray);
            this.checkParentProperty(this._data, this.selected);

            this.selectedCategories.emit(this.selected);
        }
    }

    get initialSelectedNodeTree() {
        return this._initialSelectedNodeTree;
    }

    @Output()
    selectedCategories = new EventEmitter();

    searchByText: string;

    selected: PrTreeNode[];
    searchedData: PrTreeNode[];

    private _data: PrTreeNode[];

    private _initialSelectedNodeTree: { id: number, label: string }[];

    private dataArray: number[] = [];

    constructor() {
    }

    ngOnInit(): void {

    }

    onClickActionInTree(event) {
        event.originalEvent.stopPropagation();
    }

    onNodeSelectUnselect(event) {
        this.onClickActionInTree(event);

        this.selectedCategories.emit(this.selected);
    }

    nodeSelect(event) {
        this.onClickActionInTree(event);
        this.addNode(event.node);
        this.selected = [];
        this.checkNode(this.searchedData, this.dataArray);

        this.selectedCategories.emit(this.selected);
    }

    nodeUnselect(event) {
        this.onClickActionInTree(event);
        this.removeNode(event.node);
        this.selected = [];
        this.checkNode(this._data, this.dataArray);

        this.selectedCategories.emit(this.selected);
    }


    clearSearch() {
        this.searchedData = [...this._data];
        this.searchByText = '';
        this.collapseAndIsPartialAllDisable(this.searchedData);

        this.selected = [];
        this.dataArray = [];
        this.selectedCategories.emit(this.selected);
    }

    search(term: string) {
        this.selected = [];
        this.dataArray = [];
        this.selectedCategories.emit(this.selected);
        this.collapseAndIsPartialAllDisable(this.searchedData);

        if (term) {
            const dataNode = {
                id: null,
                children: this._data,
                parentId: null,
                parent: null,
                level: null
            };

            const matchedIDS = [];
            this.dfs(dataNode, term, matchedIDS);

            this.searchedData = this.filter(this._data, matchedIDS);
            this.setIsExpanded(this.searchedData);
        } else {
            this.searchedData = [...this._data];
        }

    }

    dfs(node: PrTreeNode, term, foundIDS) {
        let isMatching = node.label && node.label.toLowerCase().indexOf(term.toLowerCase()) > -1;

        if (Array.isArray(node.children)) {
            node.children.forEach((child) => {
                const hasMatchingChild = this.dfs(child, term, foundIDS);
                isMatching = isMatching || hasMatchingChild;
            });
        }

        if (isMatching && node.id) {
            foundIDS.push(node.id);
        }

        return isMatching;
    }

    filter(data: PrTreeNode[], matchedIDS) {
        return data
            .filter((item) => matchedIDS.indexOf(item.id) > -1)
            .map((item) => {
                const prNode = {
                    ...item,
                    children: item.children ? this.filter(item.children, matchedIDS) : [],
                };

                prNode.leaf = !(prNode.children && prNode.children.length > 0);

                return prNode;
            });
    }

    clearSelected() {
        this.dataArray = [];
        this.selected = [];
        this.searchedData = [...this._data];
        this.collapseAndIsPartialAllDisable(this.searchedData);
    }

    private removeNode(node: PrTreeNode) {
        if (node.leaf) {
            this.dataArray.splice(this.dataArray.indexOf(node.id), 1);
            return;
        }
        for (let i = 0; i < node.children.length; i++) {
            this.removeNode(node.children[i]);
        }
    }

    private addNode(node: PrTreeNode) {
        if (node.leaf) {
            if (!this.dataArray.includes(node.id)) {
                this.dataArray.push(node.id);
            }
            return;
        }
        for (let i = 0; i < node.children.length; i++) {
            this.addNode(node.children[i]);
        }
    }

    private checkNode(nodes: PrTreeNode[], str: number[]) {
        for (let i = 0; i < nodes.length; i++) {
            if (!nodes[i].leaf && nodes[i].children[0].leaf) {
                for (let j = 0; j < nodes[i].children.length; j++) {
                    if (str.includes(nodes[i].children[j].id)) {
                        if (!this.selected.includes(nodes[i].children[j])) {
                            this.selected.push(nodes[i].children[j]);
                        }
                    }
                }
            }

            if (nodes[i].leaf) {
                if (str.includes(nodes[i].id)) {
                    if (!this.selected.includes(nodes[i])) {
                        this.selected.push(nodes[i]);
                    }
                }
            }

            if (!nodes[i].leaf) {
                this.checkNode(nodes[i].children, str);
                const count = nodes[i].children.length;
                let c = 0;
                for (let j = 0; j < nodes[i].children.length; j++) {
                    if (this.selected.includes(nodes[i].children[j])) {
                        c++;
                    }
                    if (nodes[i].children[j].partialSelected) {
                        nodes[i].partialSelected = true;
                    }
                }

                if (c === 0) {
                } else if (c === count) {
                    nodes[i].partialSelected = false;
                    if (!this.selected.includes(nodes[i])) {
                        this.selected.push(nodes[i]);
                    }
                } else {
                    nodes[i].partialSelected = true;
                }
            }
        }
    }

    private checkParentProperty(allNodes: PrTreeNode[], selectedNodes: PrTreeNode[]) {
        selectedNodes.forEach(selectedNode => {
            if (selectedNode.parentId && !selectedNode.parent) {
                const parent = selectedNodes.find((node) => node.id === selectedNode.parentId);

                if (!parent) {
                    selectedNode.parent = allNodes.find((allNode) => allNode.id === selectedNode.parentId);

                    if (!selectedNode.parent) {
                        allNodes.forEach((mainCat) => {
                            this.checkParentProperty(mainCat.children, [selectedNode]);
                        });
                    }

                    if (selectedNode.parent && selectedNode.parent.parentId) {
                        this.checkParentProperty(allNodes, [selectedNode.parent]);
                    }
                }
            }
        });
    }

    private collapseAndIsPartialAllDisable(nodes: PrTreeNode[]) {
        nodes.forEach(node => {
            node.expanded = false;
            node.partialSelected = false;

            if (node.children && node.children.length > 0) {
                this.collapseAndIsPartialAllDisable(node.children);
            }
        });
    }

    private setIsExpanded(nodes: PrTreeNode[]) {
        nodes.forEach(node => {
            if (node.children && node.children.length > 0) {
                node.expanded = true;

                this.collapseAndIsPartialAllDisable(node.children);
            }
        });
    }

}

export interface PrTreeNode extends TreeNode {
    id: number;
    children: PrTreeNode[];
    parent: PrTreeNode;
    parentId: number;
    level: number;
}
